import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const pagesApi = createApi({
  reducerPath: "pagesApi",
  baseQuery,
  tagTypes: ["pages", "page-details"],
  endpoints: (builder) => ({
    getPages: builder.query({
      query: () => "/pages",
      providesTags: ["pages"],
    }),
    getPageDetails: builder.query({
      query: (slug) => `/page/${slug}`,
      providesTags: ["page-details"],
    }),
  }),
});

export const { useLazyGetPagesQuery, useLazyGetPageDetailsQuery } = pagesApi;
